<template>
  <div>
    <v-dialog
      :fullscreen="$vuetify.breakpoint.xs"
      persistent
      v-model="dialog"
      width="60vw"
    >
      <v-card>
        <v-toolbar color="primary">
          <v-toolbar-title>Edit Campaign Crypto</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="$emit('onClose')" :disabled="isEditing">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text v-show="!isEditing">
          <div class="body__form">
            <v-form ref="formCampaign" v-model="valid" lazy-validation>
              <v-radio-group row v-model="form.campaign_type">
                <v-radio
                  disabled
                  color="primary"
                  label="Airdrop"
                  value="airdrop"
                ></v-radio>
                <v-radio
                  disabled
                  color="primary"
                  label="Redeem"
                  value="redeem"
                ></v-radio>
              </v-radio-group>
              <v-divider color="cornflowerblue"></v-divider>
              <v-layout row wrap class="mt-3">
                <v-flex xs12 sm6 class="pr-2">
                  <v-text-field
                    :rules="[rules.required]"
                    label="Title TH"
                    v-model="form.campaign_title_th"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 sm6 class="pr-2">
                  <v-text-field
                    label="Title EN"
                    v-model="form.campaign_title_en"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm6 class="pr-2">
                  <v-textarea
                    :rules="[rules.required]"
                    label="Description TH"
                    v-model="form.campaign_description_th"
                  >
                  </v-textarea>
                </v-flex>
                <v-flex xs12 sm6 class="pr-2">
                  <v-textarea
                    label="Description EN"
                    v-model="form.campaign_description_en"
                    :rules="[rules.required]"
                  ></v-textarea>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm6 class="pr-2">
                  <v-select
                    label="Limit per user"
                    :items="[
                      { name: 'Yes', value: true },
                      { name: 'No', value: false },
                    ]"
                    item-text="name"
                    item-value="value"
                    v-if="form.campaign_type == 'redeem'"
                    row
                    v-model="isLimitUser"
                    @change="form.campaign_amount_per_user = 0"
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12 sm6 class="pr-2">
                  <v-text-field
                    v-if="form.campaign_type == 'redeem' && isLimitUser == true"
                    :rules="[rules.required, rules.moreThan, rules.onlyNumber]"
                    v-model="form.campaign_amount_per_user"
                    label="Amount Per User"
                    type="number"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex
                  xs6
                  sm6
                  class="pr-2"
                  v-if="form.campaign_type == 'redeem'"
                >
                  <v-text-field
                    :rules="[rules.required, rules.point, rules.onlyNumber]"
                    v-model="form.campaign_amount_point"
                    label="Amount point"
                    type="number"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 sm6 class="pr-2">
                  <v-text-field
                    :rules="[rules.required, rules.moreThan]"
                    v-model="form.campaign_amount_token"
                    label="Amount token"
                    type="number"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-text-field
                :rules="[rules.required, rules.moreThan, rules.onlyNumber]"
                v-model="form.campaign_amount_redeem"
                label="Total Amount"
                type="number"
              ></v-text-field>

              <v-layout row wrap v-if="form.campaign_type == 'redeem'">
                <v-flex xs12 sm6 class="pr-2">
                  <v-menu
                    ref="menuDateStart"
                    v-model="menuDateStart"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="form.campaign_start_date"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="form.campaign_start_date"
                        label="Start Date"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                        :rules="[
                          rules.required,
                          moment(form.campaign_start_date) <
                            moment(form.campaign_end_date) ||
                            'invalid date start - end',
                        ]"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      :min="moment().format('YYYY-MM-DD')"
                      color="black"
                      v-model="form.campaign_start_date"
                      year-icon="mdi-calendar-blank"
                      prev-icon="mdi-skip-previous"
                      next-icon="mdi-skip-next"
                      @change="
                        $refs.menuDateStart.save(form.campaign_start_date)
                      "
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm6 class="pr-2">
                  <v-menu
                    ref="menuDateEnd"
                    v-model="menuDateEnd"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="form.campaign_end_date"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="form.campaign_end_date"
                        label="End Date"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                        :rules="[
                          rules.required,
                          moment(form.campaign_start_date) <
                            moment(form.campaign_end_date) ||
                            'invalid date start - end',
                        ]"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      :min="moment().format('YYYY-MM-DD')"
                      color="black"
                      v-model="form.campaign_end_date"
                      year-icon="mdi-calendar-blank"
                      prev-icon="mdi-skip-previous"
                      next-icon="mdi-skip-next"
                      @change="$refs.menuDateEnd.save(form.campaign_end_date)"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>

              <v-divider class="my-3" color="cornflowerblue"></v-divider>
              <v-layout row align-center class="mt-3">
                <span style="font-size: 16px">Upload image:</span>
                <v-btn
                  icon
                  color="info"
                  class="white--text"
                  @click="$refs.LogoInput.click()"
                >
                  <v-icon dark>cloud_upload</v-icon>
                </v-btn>
                <input
                  style="display: none"
                  type="file"
                  @change="onLogoSelected"
                  ref="LogoInput"
                  accept="image/*"
                />
              </v-layout>

              <v-img
                :src="imageSrc"
                v-if="imageSrc"
                width="100px"
                height="100px"
              />
              <v-img
                :src="form.campaign_image"
                v-else
                width="100px"
                height="100px"
              />
              <v-divider class="my-3" color="cornflowerblue"></v-divider>
              <v-layout row align-center>
                <span style="font-size: 18px">Condition detail</span>
                <v-divider class="mx-2" inset vertical></v-divider>
                <v-btn
                  color="success"
                  icon
                  @click="
                    form.campaign_condition_detail.push({
                      th: '',
                      en: '',
                    })
                  "
                >
                  <v-icon>add</v-icon>
                </v-btn>
              </v-layout>
              <v-layout
                row
                v-for="(condition, key) in form.campaign_condition_detail"
                :key="key"
                class="pa-3 mt-3"
                style="
                  border: 1px solid black;
                  border-radius: 10px;
                  display: flex;
                  justify-content: space-between;
                "
              >
                <v-flex xs10>
                  <v-layout row wrap>
                    <v-flex xs12 md6 class="pr-2">
                      <v-text-field
                        :rules="[rules.required]"
                        label="Condition TH"
                        v-model="condition.th"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 md6 class="pr-2">
                      <v-text-field
                        :rules="[rules.required]"
                        label="Condition EN"
                        v-model="condition.en"
                      >
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs1 style="display: flex; justify-content: center">
                  <v-btn
                    color="error"
                    icon
                    small
                    @click="removeConditionDetail(key)"
                    v-if="key > 0"
                  >
                    <v-icon small>close</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-form>
          </div>
        </v-card-text>
        <v-card-text v-show="isEditing" class="text-xs-center">
          <div class="body__form">
            <span>Creating campaign crpyto ...</span>
            <v-progress-linear
              :indeterminate="true"
              color="primary"
            ></v-progress-linear>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions
          v-show="!isEditing"
          style="display: flex; justify-content: flex-end; align-items: center"
        >
          <v-btn
            flat
            color="error"
            style="border: 1px solid red"
            @click="$emit('onClose')"
            >cancel</v-btn
          >
          <v-btn
            flat
            color="success"
            style="border: 1px solid green"
            @click="editCampaign()"
            >save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="openSnackbar" color="black" :timeout="3000">
      <v-icon color="warning" class="pr-1">warning</v-icon>
      {{ snackbarMsg }}
      <v-btn icon @click="openSnackbar = false">
        <v-icon color="red">close</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import XLSX from "./../../../../node_modules/xlsx/dist/xlsx.full.min.js";
export default {
  props: ["dialog", "form"],
  data() {
    return {
      isLimitUser: false,
      snackbarMsg: "",
      openSnackbar: false,
      customerTableHeaders: [
        {
          text: "customer_id",
          align: "left",
          sortable: false,
        },
        {
          text: "customer_first_name",
          align: "center",
          sortable: false,
          value: "",
        },
        {
          text: "customer_last_name",
          align: "center",
          sortable: false,
          value: "",
        },
        {
          text: "wallet_address",
          align: "center",
          sortable: false,
          value: "",
        },
        {
          text: "wallet_provider",
          align: "center",
          sortable: false,
          value: "",
        },
      ],
      valid: true,
      isEditing: false,
      menuDateStart: false,
      menuDateEnd: false,
      rules: {
        onlyNumber: (value) => /^[^\W_]+$/.test(value) || "invalid format",
        moreThan: (value) => value > "0" || "More than zero.",
        point: (value) => value >= "0" || "invalid amount point.",
        required: (value) => value == "0" || !!value || "Required.",
        maxCode: (v) => v.length <= 6 || "No more than 6 characters",
      },
      imageSrc: "",
    };
  },
  watch: {
    dialog() {
      if (this.dialog == true) {
        this.isEditing = false;
        this.imageSrc = "";
        if (this.form.campaign_amount_per_user == 0) {
          this.isLimitUser = false;
        } else {
          this.isLimitUser = true;
        }
      }
    },
  },
  computed: {},
  methods: {
    ...mapActions({
      editCampaignCrypto: "campaigns/editCampaignCrypto",
    }),

    removeConditionDetail(key) {
      if (this.form.campaign_condition_detail.length > 1) {
        this.form.campaign_condition_detail.splice(key, 1);
      }
    },
    async editCampaign() {
      if (this.$refs.formCampaign.validate()) {
        let payload = JSON.parse(JSON.stringify(this.form));

        if (this.imageSrc == "") {
          delete payload.campaign_image;
        } else {
          payload.campaign_image = this.imageSrc;
        }

        this.isEditing = true;
        let result = await this.editCampaignCrypto(payload);

        if (result == false) return (this.isEditing = false);

        this.$emit("onEdited", result);
      }
    },

    onLogoSelected(event) {
      let file = event.target.files[0];
      let reader = new FileReader();
      reader.addEventListener("load", () => {
        this.imageSrc = reader.result;
      });
      reader.readAsDataURL(file);
      event.target.value = "";
    },
  },
};
</script>

<style scoped>
.body__form {
  max-height: 400px;
  overflow: auto;
}

.body__form::-webkit-scrollbar {
  display: none;
}
</style>
